module.exports = __webpack_public_path__ + "img/FTSE.ec3c43ac.png";